<script setup lang="ts">
const runtimeConfig = useRuntimeConfig()
const { params, query, path } = useRoute()
const store = useCategoryStore()
await store.init({ id: params.id, url: path })
const { blog, name, description, breadcrumbs, category_categoryFooterDescription, category_categoryFooterImage, category_youtubeId, category_categoryFooterMap, category_categoryHeaderTable, category_subcategoryH2, availableSortings, metaTitle, metaDescription } = storeToRefs(store)
const table = computed(() => category_categoryHeaderTable.value ? JSON.parse(category_categoryHeaderTable.value) : null)
const map = computed(() => category_categoryFooterMap.value ? JSON.parse(category_categoryFooterMap.value) : null)
const icon = (name: string) => {
  switch (name) {
    case 'nawierzchnia':
      return '/nawi_120.png'
    case 'długość':
      return '/dlug_120.png'
    case 'szerokość':
      return '/szer_120.png'
    case 'zakręty':
      return '/zakr_120.png'
    case 'najdłuższa prosta':
      return '/pros_120.png'
    case 'typ':
      return '/typw_120.png'
    default:
      return '/nawi_120.png'
  }
}
let param = Object.entries(Object.fromEntries(Object.entries(query).filter(([key]) => ['min-price', 'max-price', 'properties', 'order', 'p'].includes(key)))).map(([key, val]) => `${key}=${encodeURIComponent(val)}`).join('&')
let robots = 'index,follow'
if (param.length) {
  param = `?${param}`
  robots = 'noindex,follow'
}
useHead({
  titleTemplate: `${metaTitle.value} - %s`,
  meta: [
    { name: 'description', content: metaDescription.value },
    { name: 'robots', content: robots }
  ],
  link: [
    { rel: 'canonical', href: `${runtimeConfig.public.baseUrl}${path}${param}` }
  ]
})
</script>

<template>
  <div class="container mx-auto">
    <Breadcrumbs :breadcrumbs="breadcrumbs" />
    <h1 class="text-18 font-bold mb-[20px]">
      {{ name }}
    </h1>
    <div class="flex flex-col justify-between items-center md:items-start mb-[20px] gap-[20px]">
      <div v-if="description">
        <div v-html="formatHtml(description)" />
      </div>
      <div v-if="table" class="w-full">
        <div class="mb-[5px]">
          Dane toru:
        </div>
        <div class="flex flex-wrap gap-[30px]">
          <div class="flex flex-col items-center">
            <div class="bg-gray-200 rounded-full mb-[10px]">
              <Img
                v-if="icon(table.head[0])"
                :src="icon(table.head[0])"
                width="120"
                height="120"
                alt=""
                class="p-[15px]"
              />
            </div>
            <div>
              {{ table.head[0] }}
            </div>
            <div class="font-bold">
              {{ table.head[1] }}
            </div>
          </div>
          <div v-for="row in table.body" :key="row.name" class="flex flex-col items-center">
            <div class="bg-gray-200 rounded-full mb-[10px]">
              <Img
                v-if="icon(row.name)"
                :src="icon(row.name)"
                width="120"
                height="120"
                alt=""
                class="p-[15px]"
              />
            </div>
            <div>
              {{ row.name }}
            </div>
            <div class="font-bold">
              {{ row.value }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :class="{ 'justify-between': category_subcategoryH2, 'justify-end': !category_subcategoryH2 }" class="md:flex items-center mb-[20px]">
      <h2 v-if="category_subcategoryH2" class="col-span-3 text-18 font-bold">
        {{ category_subcategoryH2 }}
      </h2>
      <Sort :available-sortings="availableSortings" />
    </div>
    <ProductListCategory class="mb-[50px]" />
    <div class="flex flex-col md:flex-row gap-[15px] mb-[20px]">
      <Img
        v-if="category_categoryFooterImage"
        :src="category_categoryFooterImage.url"
        width="737"
        height="347"
        :alt="category_categoryFooterImage.alt"
        class="flex justify-end min-w-[50%]"
      />
      <ClientOnly>
        <LazyTorGoogleMaps v-if="map" :supplier-position="map" class="w-full" />
      </ClientOnly>
    </div>
    <div v-html="formatHtml(category_categoryFooterDescription)" class="mb-[50px]" />
    <Youtube v-if="category_youtubeId" :id="category_youtubeId" class="!h-[355px] md:!h-[455px] mb-[20px]" />
    <Blog v-if="blog.length" :blog="blog" class="mb-[50px]" />
  </div>
</template>
